import { styled } from '@withjoy/joykit';

export const OuterElementWrapper = styled.div`
  position: relative;
  width: 100%;
`;
